import React, { Suspense } from 'react'

interface SuspenseWrapperProps {
    children: React.ReactNode
    fallback?: React.ReactNode
}

const SuspenseWrapper: React.FC<SuspenseWrapperProps> = ({ 
    children, 
    fallback = <div>Loading...</div> 
}) => {
    return (
        <Suspense fallback={fallback}>
            {children}
        </Suspense>
    )
}

export const withSuspenseWrapper = <P extends object>(
    Component: React.ComponentType<P>
): React.FC<P> => {
    return (props: P) => (
        <SuspenseWrapper>
            <Component {...props} />
        </SuspenseWrapper>
    )
}

export default SuspenseWrapper
